<template>
  <div class="wa-step wa-step--migration-warning">
    <h2 class="wa-step__heading">
      {{ t(`${baseKey}.heading`) }}
    </h2>
    <p class="wa-step__lead">
      {{ t(`${baseKey}.lead`) }}
    </p>
    <div
      class="wa-step__warning-panel"
      :class="{ 'wa-step__warning-panel--with-title': variant === 'other_bsp' }"
    >
      <p
        v-if="variant === 'other_bsp'"
        class="wa-step__warning-panel-title"
      >
        {{ t(`${baseKey}.panelTitle`) }}
      </p>
      <div class="wa-step__warning-panel-banner">
        <i class="fa-solid fa-circle-info" />
        <span>{{ t(`${baseKey}.banner`) }}</span>
      </div>
      <ol class="wa-step__numbered-list">
        <li>
          <strong>{{ t(`${baseKey}.step1Title`) }}</strong>
          <p>{{ t(`${baseKey}.step1Description`) }}</p>
        </li>
        <li>
          <strong>{{ t(`${baseKey}.step2Title`) }}</strong>
          <p>{{ t(`${baseKey}.step2Description`) }}</p>
        </li>
      </ol>
    </div>
    <button
      type="button"
      class="wa-step__link-button"
      @click="$emit('want-new-number')"
    >
      {{ t(`${baseKey}.wantNewNumber`) }}
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'WhatsappMigrationWarningStep',

  props: {
    variant: {
      type: String as PropType<'wa_app' | 'other_bsp'>,
      default: 'wa_app',
    },
  },

  emits: ['want-new-number'],

  setup(props) {
    const { t } = useI18n();

    const baseKey = computed(() => (
      props.variant === 'other_bsp'
        ? 'storeParameters.services.whatsappBusinessParameter.onboarding.paths.otherBsp.migration'
        : 'storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.warning'
    ));

    return { t, baseKey };
  },
});
</script>
